module.exports = __webpack_public_path__ + "img/Ausblick.21aea634.svg";